import { render, staticRenderFns } from "./RecursiveRow.vue?vue&type=template&id=a52dffd6&scoped=true&"
import script from "./RecursiveRow.vue?vue&type=script&lang=js&"
export * from "./RecursiveRow.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveRow.vue?vue&type=style&index=0&id=a52dffd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52dffd6",
  null
  
)

export default component.exports